var CartSaveForLater = (function () {
  if (!/^(\/[a-z]{2}(-[a-z]{2})?)?\/cart\/?$/i.test(window.location.pathname)) return
  var CACHE_KEY = 'nydj:sfl:' + (window.swymCustomerId || 'guest')
  var GUEST_SFL_KEY = 'nydj:sfl-guest'
  var AUTH_TIMEOUT = 5000

  function noop() {}

  var swat = null
  var sflListId = null
  var sflItems = []
  var sflContainer = null
  var initialized = false
  var isLoggedIn = !!window.swymCustomerId
  var priceRequests = {}
  var pendingSaves = []
  var sflUnavailable = false

  function init() {
    sflContainer = document.getElementById('sfl-section')
    if (!sflContainer) return

    attachSaveListeners()

    var cached = readCache()
    if (cached) {
      sflListId = cached.lid || null
      sflItems = cached.items || []
      renderSection()
    }

    window.SwymCallbacks = window.SwymCallbacks || []
    window.SwymCallbacks.push(onSwymReady)

    if (window._swat && window._swat.SaveForLater) {
      onSwymReady(window._swat)
      return
    }

    var pollCount = 0
    var maxPolls = 75
    var pollInterval = setInterval(function () {
      pollCount++
      if (initialized) {
        clearInterval(pollInterval)
        return
      }
      if (window._swat && window._swat.SaveForLater) {
        clearInterval(pollInterval)
        onSwymReady(window._swat)
      } else if (pollCount >= maxPolls) {
        clearInterval(pollInterval)
        sflUnavailable = true
        cancelPendingSaves()
      }
    }, 200)
  }

  function onSwymReady(_swat) {
    if (initialized) return
    initialized = true
    swat = _swat

    if (swat.evtLayer && swat.JSEvents && swat.JSEvents.customerInfoRefreshed) {
      swat.evtLayer.addEventListener(swat.JSEvents.customerInfoRefreshed, function () {
        sflListId = null
        if (swat.SaveForLater) initSFL()
      })
    }

    var SFL = swat.SaveForLater
    if (!SFL || typeof SFL.init !== 'function') {
      sflUnavailable = true
      cancelPendingSaves()
      return
    }

    if (typeof swat.initCartItemRemoveButtons === 'function') {
      swat.initCartItemRemoveButtons = function () {}
    }

    if (isLoggedIn && typeof swat.authCheck === 'function') {
      var authDone = false
      var proceed = function () {
        if (authDone) return
        authDone = true
        initSFL()
      }
      swat.authCheck(proceed)
      setTimeout(proceed, AUTH_TIMEOUT)
    } else {
      initSFL()
    }

  }

  function extractListId(response) {
    if (response && response.list && response.list.lid) return response.list.lid
    if (response && response.lid) return response.lid
    if (response && response.listid) return response.listid
    return null
  }

  function initSFL() {
    swat.SaveForLater.init(
      function (response) {
        sflListId = extractListId(response)
        if (!sflListId) {
          sflUnavailable = true
          cancelPendingSaves()
          return
        }
        sflUnavailable = false
        fetchSFLItems()
      },
      function () {
        sflUnavailable = true
        cancelPendingSaves()
      }
    )
  }

  function fetchSFLItems() {
    if (!swat || !swat.SaveForLater || !sflListId) return

    swat.SaveForLater.fetch(
      sflListId,
      function (response) {
        if (response && Array.isArray(response.items)) {
          sflItems = response.items
        } else if (Array.isArray(response)) {
          sflItems = response
        } else {
          sflItems = []
        }
        writeCache()
        renderSection()
        flushPendingSaves()
      },
      flushPendingSaves
    )
  }

  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY)
      if (!raw) return null
      var parsed = JSON.parse(raw)
      return parsed && Array.isArray(parsed.items) ? parsed : null
    } catch (e) {
      return null
    }
  }

  function writeCache() {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ lid: sflListId, items: sflItems }))
    } catch (e) {}
    writeGuestCopy()
  }

  function writeGuestCopy() {
    if (window.swymCustomerId) return
    if (swat && typeof swat.isAlreadyAuth === 'function' && swat.isAlreadyAuth()) return
    try {
      if (!sflItems.length) {
        localStorage.removeItem(GUEST_SFL_KEY)
        return
      }
      localStorage.setItem(GUEST_SFL_KEY, JSON.stringify({
        owner: 'guest',
        attempts: 0,
        items: sflItems.map(function (item) {
          return {
            empi: item.empi,
            epi: item.epi,
            du: canonicalUrl(item.du || ''),
            dt: item.dt,
            iu: item.iu,
            pr: item.pr,
            cprops: item.cprops || {}
          }
        })
      }))
    } catch (e) {}
  }

  function attachSaveListeners() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.save-for-later-btn')
      if (btn) handleSaveForLater(e)
    })
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.closest('.save-for-later-btn')) {
        e.target.click()
      }
    })
  }

  function handleSaveForLater(e) {
    e.preventDefault()
    var btn = e.target.closest('.save-for-later-btn') || e.target
    var row = btn.closest('.cart-items__row')
    if (!row || btn.dataset.saving || sflUnavailable) return

    var product = buildProductFromRow(row)
    if (!product) return

    btn.dataset.saving = '1'
    btn.style.pointerEvents = 'none'
    btn.style.opacity = '0.5'
    btn.textContent = 'Saving…'

    if (!swat || !swat.SaveForLater || !sflListId) {
      pendingSaves.push({ row: row, btn: btn, product: product })
      return
    }

    performSave(row, btn, product)
  }

  function flushPendingSaves() {
    var queued = pendingSaves
    pendingSaves = []
    queued.forEach(function (entry) {
      if (!entry.row.isConnected || !swat || !swat.SaveForLater || !sflListId) {
        resetSaveButton(entry.btn)
        return
      }
      performSave(entry.row, entry.btn, entry.product)
    })
  }

  function cancelPendingSaves() {
    var queued = pendingSaves
    pendingSaves = []
    queued.forEach(function (entry) { resetSaveButton(entry.btn) })
  }

  function resetSaveButton(btn) {
    delete btn.dataset.saving
    btn.style.pointerEvents = ''
    btn.style.opacity = ''
    btn.textContent = 'Save for Later'
  }

  function performSave(row, btn, product) {
    var wasAlreadySaved = sflItems.some(function (item) { return String(item.epi) === String(product.epi) })

    swat.SaveForLater.add(
      sflListId,
      [product],
      function () {
        confirmSaved(product, function (stored) {
          if (!stored) {
            rejectSave(btn)
            return
          }

          if (!wasAlreadySaved) {
            sflItems = sflItems.concat([product])
          }
          writeCache()

          var lineItemKey = row.dataset.lineItemKey || row.dataset.variantId
          removeFromShopifyCart(lineItemKey, function () {
            window.location.reload()
          }, function () {
            if (!wasAlreadySaved) {
              dropFromCache(product)
              swat.SaveForLater.remove(sflListId, [removalPayload(product)], noop, noop)
            }
            resetSaveButton(btn)
          })
        })
      },
      function () {
        resetSaveButton(btn)
      }
    )
  }

  function confirmSaved(product, callback) {
    swat.SaveForLater.fetch(
      sflListId,
      function (response) {
        var items = (response && response.items) || []
        callback(items.some(function (item) { return String(item.epi) === String(product.epi) }))
      },
      function () { callback(false) }
    )
  }

  function rejectSave(btn) {
    delete btn.dataset.saving
    btn.style.pointerEvents = ''
    btn.style.opacity = '0.5'
    btn.textContent = 'Unavailable'
  }

  function buildProductFromRow(row) {
    var variantId = row.dataset.variantId
    var productId = row.dataset.productId
    if (!variantId || !productId) return null

    var priceCents = row.dataset.productPrice ? parseInt(row.dataset.productPrice, 10) : 0
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || ''

    return {
      epi: parseInt(variantId, 10),
      empi: parseInt(productId, 10),
      du: canonicalUrl(row.dataset.productUrl || ''),
      dt: row.dataset.productTitle || '',
      iu: row.dataset.productImage || '',
      pr: priceCents / 100,
      cprops: {
        variant_title: row.dataset.variantTitle || '',
        presentment_price: String(priceCents),
        presentment_currency: currency
      }
    }
  }

  function canonicalUrl(url) {
    return String(url).split('?')[0].split('#')[0]
  }

  function removeFromShopifyCart(itemKey, onDone, onFail) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: 0 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status)
        return r.json()
      })
      .then(function () { onDone() })
      .catch(function () { onFail() })
  }

  function handleMoveToBag(index) {
    var item = sflItems[index]
    if (!item || !swat || !swat.SaveForLater || !sflListId) return

    var btn = sflContainer.querySelector('.sfl-move-to-bag-btn[data-index="' + index + '"]')
    if (btn) {
      btn.style.pointerEvents = 'none'
      btn.style.opacity = '0.5'
      btn.textContent = 'Moving…'
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.epi, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status)
        return r.json()
      })
      .then(function () {
        if (!swat || !swat.SaveForLater || !sflListId) {
          window.location.reload()
          return
        }
        dropFromCache(item)
        swat.SaveForLater.remove(
          sflListId,
          [removalPayload(item)],
          function () { window.location.reload() },
          function () { window.location.reload() }
        )
      })
      .catch(function () {
        if (btn) {
          btn.style.opacity = '0.5'
          btn.textContent = 'Sold out'
        }
      })
  }

  function handleRemoveFromSFL(index) {
    var item = sflItems[index]
    if (!item || !swat || !swat.SaveForLater || !sflListId) return

    var btn = sflContainer.querySelector('.sfl-remove-btn[data-index="' + index + '"]')
    if (btn) {
      btn.style.pointerEvents = 'none'
      btn.style.opacity = '0.5'
      btn.textContent = 'Removing…'
    }

    swat.SaveForLater.remove(
      sflListId,
      [removalPayload(item)],
      function () {
        dropFromCache(item)
        renderSection()
        fetchSFLItems()
      },
      function () {
        if (btn) {
          btn.style.pointerEvents = ''
          btn.style.opacity = ''
          btn.textContent = 'Remove'
        }
      }
    )
  }

  function removalPayload(item) {
    return { epi: item.epi, empi: item.empi, du: canonicalUrl(item.du || '') }
  }

  function dropFromCache(item) {
    sflItems = sflItems.filter(function (entry) {
      return String(entry.epi) !== String(item.epi)
    })
    writeCache()
  }

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
  }

  function withDelimiters(amount, decimals, thousands, decimal) {
    var fixed = amount.toFixed(decimals)
    var parts = fixed.split('.')
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1' + thousands)
    return parts[1] ? whole + decimal + parts[1] : whole
  }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}'
    var amount = cents / 100
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, name) {
      switch (name) {
        case 'amount_no_decimals':
          return withDelimiters(amount, 0, ',', '.')
        case 'amount_with_comma_separator':
          return withDelimiters(amount, 2, '.', ',')
        case 'amount_no_decimals_with_comma_separator':
          return withDelimiters(amount, 0, '.', ',')
        case 'amount_with_space_separator':
          return withDelimiters(amount, 2, ' ', ',')
        case 'amount_no_decimals_with_space_separator':
          return withDelimiters(amount, 0, ' ', ',')
        case 'amount_with_period_and_space_separator':
          return withDelimiters(amount, 2, ' ', '.')
        default:
          return withDelimiters(amount, 2, ',', '.')
      }
    })
  }

  function priceHtml(item) {
    var active = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || ''
    var cprops = item.cprops || {}
    if (cprops.presentment_price && (!cprops.presentment_currency || cprops.presentment_currency === active)) {
      return formatMoney(parseInt(cprops.presentment_price, 10))
    }
    return ''
  }

  function hydratePrices() {
    sflItems.forEach(function (item, i) {
      var target = sflContainer.querySelector('.sfl-item__price[data-index="' + i + '"]')
      if (!target || target.textContent.trim()) return

      var handle = (canonicalUrl(item.du || '').match(/\/products\/([^/?#]+)/) || [])[1]
      if (!handle) return

      if (!priceRequests[handle]) {
        priceRequests[handle] = fetch('/products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null })
          .catch(function () { return null })
      }

      priceRequests[handle].then(function (product) {
        if (!target.isConnected) return
        if (!product) {
          if (item.pr) target.textContent = formatMoney(Math.round(parseFloat(item.pr) * 100))
          return
        }
        var variant = product.variants.filter(function (v) {
          return String(v.id) === String(item.epi)
        })[0]
        target.textContent = formatMoney(variant ? variant.price : product.price)
      })
    })
  }

  function renderSection() {
    if (!sflContainer) return

    if (!sflItems || sflItems.length === 0) {
      sflContainer.style.display = 'none'
      sflContainer.innerHTML = ''
      return
    }

    sflContainer.style.display = 'block'

    var count = sflItems.length
    var label = count === 1 ? 'Item' : 'Items'

    var html = ''
    html += '<div class="sfl-header">'
    html += '<h2 class="sfl-title h3">Saved for Later (' + count + ' ' + label + ')</h2>'
    html += '</div>'
    html += '<div class="sfl-items">'

    sflItems.forEach(function (item, i) {
      var fullTitle = item.dt || ''
      var productTitle = fullTitle.split(' - ')[0] || ''
      var color = fullTitle.split(' - ')[1] || ''
      var variantTitle = (item.cprops && item.cprops.variant_title) || ''
      var imageUrl = item.iu || ''
      var productUrl = item.du || '#'

      html += '<div class="sfl-item">'
      html += '  <div class="sfl-item__image">'
      html += '    <a href="' + esc(productUrl) + '"><img src="' + esc(imageUrl) + '" alt="' + esc(productTitle) + '"></a>'
      html += '  </div>'
      html += '  <div class="sfl-item__details">'
      html += '    <a href="' + esc(productUrl) + '"><p class="sfl-item__name">' + esc(productTitle) + '</p></a>'
      if (color) {
        html += '    <p><small>Color: ' + esc(color) + '</small></p>'
      }
      if (variantTitle && variantTitle !== 'Default Title') {
        html += '    <p><small>Size: ' + esc(variantTitle) + '</small></p>'
      }
      html += '    <p class="sfl-item__price" data-index="' + i + '">' + esc(priceHtml(item)) + '</p>'
      html += '    <p class="sfl-item__actions">'
      html += '      <span class="sfl-remove-btn" data-index="' + i + '" tabindex="0" role="button" aria-label="Remove">Remove</span>'
      html += '      <span class="sfl-item__separator">|</span>'
      html += '      <span class="sfl-move-to-bag-btn" data-index="' + i + '" tabindex="0" role="button" aria-label="Move to Bag">Move to Bag</span>'
      html += '    </p>'
      html += '  </div>'
      html += '</div>'
    })

    html += '</div>'
    sflContainer.innerHTML = html

    sflContainer.querySelectorAll('.sfl-remove-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        handleRemoveFromSFL(parseInt(btn.dataset.index, 10))
      })
      btn.addEventListener('keydown', function (e) { if (e.key === 'Enter') btn.click() })
    })

    sflContainer.querySelectorAll('.sfl-move-to-bag-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        handleMoveToBag(parseInt(btn.dataset.index, 10))
      })
      btn.addEventListener('keydown', function (e) { if (e.key === 'Enter') btn.click() })
    })

    hydratePrices()
  }

  if (document.readyState !== 'loading') {
    init()
  } else {
    document.addEventListener('DOMContentLoaded', init)
  }

  return { refresh: fetchSFLItems }
})()
